import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

import Routes from './Routes';
import { navLink } from '../styles/link';
import { media, animation } from '../styles/constants';

const { shortAnimationDuration } = animation;

// [Style] Mobile Menu Links Style
const MobileRoutes = styled.div`
  display: ${props => (props.isMenuOpen ? 'flex' : 'none')};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;

  @media (min-width: ${media.tabletPortrait}) {
    display: none;
  }

  &.menu-appear-active,
  &.menu-enter-active {
    opacity: 0;
    visibility: hidden;
  }

  &.menu-enter-done {
    opacity: 1;
    visibility: visible;
    transition: opacity, visibility ${shortAnimationDuration}ms ease-out;
  }

  &.menu-exit {
    opacity: 1;
    visibility: visible;
  }

  &.menu-exit-done {
    opacity: 0;
    visibility: hidden;
    transition: opacity, visibility ${shortAnimationDuration}ms ease-out;
  }

  && a {
    padding: 1rem 0;
    margin-bottom: 4rem;
    margin-right: 0; // navLink reset
    font-size: 3.4rem;
    ${navLink}

    &:after {
      top: 5rem;
    }
  }
`;

const MobileMenu = ({ isMenuOpen, onClick }) => (
  <CSSTransition
    classNames="menu"
    timeout={shortAnimationDuration}
    in={isMenuOpen}
    appear
  >
    <MobileRoutes isMenuOpen={isMenuOpen}>
      <Routes onClick={onClick} />
    </MobileRoutes>
  </CSSTransition>
);

MobileMenu.propTypes = {
  isMenuOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default MobileMenu;
